import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_DASHBOARD } from '../routes/paths';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, user } = useAuth();

  console.log(user  ,'user')

  let navigateTo = '';
  if (user?.isSuperAdmin === true) {
    navigateTo = PATH_DASHBOARD.seller.list;
  } else {
    navigateTo = PATH_DASHBOARD.seller.list;
  }
  if (isAuthenticated) {
    return <Navigate to={navigateTo} />;
  }

  return <>{children}</>;
}
